import React, {Component} from 'react';

import Select from '../common/select'
import BarChart from './components/barChart'
import _ from 'lodash';
import axios from "axios/index";


import './styles.scss';
import Category from "./components/category/Category";
import morning from "../../../assets/morning.png"
import afternoon from "../../../assets/afternoon.png"
import night from "../../../assets/night.png"
import urls from "../../../utils/urls";
import {tokenHeader} from "../../../utils/headers";
import {ajaxHandler} from "../../../utils/errors";
import LoadingSpinner from "../../../components/spinner/Spinner";
import {connect} from "react-redux";
import VerticalAlign from "../../../components/verticalAlign/VerticalAlign";

class PerformancePerTurn extends Component {

    constructor(props) {
        super(props);
        this.state = {
            filteredKeys: [],
            data: false,
            filteredData: false,
            xhr: false,
            axiosSource: null,
        }
    }

    componentDidMount(){
        if (this.props.stations.list) {
            if (this.props.filters) {
                this.setState({selectedValue: this.props.filters[this.props.filters.length - 1], data: false}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((this.props.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (this.props.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (this.props.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this._fetchData();
                }
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stations.list) {
            if (nextProps.filters) {
                this.setState({selectedValue: nextProps.filters[nextProps.filters.length - 1]}, () => {
                    this._fetchData();
                })
            }

            if (this.state.selectedValue) {
                if ((nextProps.navigation.selectedArea !== this.props.navigation.selectedArea) ||
                    (nextProps.navigation.selectedZone !== this.props.navigation.selectedZone) ||
                    (nextProps.navigation.selectedStation !== this.props.navigation.selectedStation)) {
                    this.setState({
                        data: false,
                        filteredData: false
                    }, this._fetchData);
                }
            }
        }
    }

    onValueChange = (ev) => {
        this.setState({selectedValue: ev.target.value}, () => {
            this._fetchData()
        })
    };

    _getColorByFuel = (fuel) => {
        switch (fuel) {
            case "Super Nafta":
                return '#DD1D21';
            case "V-Power Nafta":
                return "#00B050";
            case "V-Power Diesel":
                return "#0099FF";
        }
    };

    _getFormattedData = () => {
        let dataMorning = [];
        let dataAfternoon = [];
        let dataNight = [];
        this.state.data.forEach((product) => {
            dataMorning.push({
                name: product.product_display,
                color: this._getColorByFuel(product.product_display),
                data: [product.data["06_13"][1], product.data["06_13"][0]]
            })
        });
        this.state.data.forEach((product) => {
            dataAfternoon.push({
                name: product.product_display,
                color: this._getColorByFuel(product.product_display),
                data: [product.data["14_21"][1], product.data["14_21"][0]]
            })
        });
        this.state.data.forEach((product) => {
            dataNight.push({
                name: product.product_display,
                color: this._getColorByFuel(product.product_display),
                data: [product.data["22_05"][1], product.data["22_05"][0]]
            })
        });

        return {dataMorning, dataAfternoon, dataNight};
    };

    _fetchData = () => {
        if (this.state.xhr) {
            this.state.axiosSource.cancel('abort');
        }
        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        this.setState({xhr: true, axiosSource: source});

        if (this.state.selectedValue) {
            let user_details_url = `${urls.API_ROOT}/api/v1/daytime-performance/?quarter=${this.state.selectedValue.quarter ?
                this.state.selectedValue.quarter : "Q3"}&year=${this.state.selectedValue.year ? this.state.selectedValue.year : "2018"}`;
            if (this.props.navigation.selectedArea !== -1) {
                user_details_url = user_details_url.concat(`&area_id=${this.props.navigation.selectedArea}`);
            }
            if (this.props.navigation.selectedZone !== -1) {
                user_details_url = user_details_url.concat(`&zone_id=${this.props.navigation.selectedZone}`);
            }
            if (this.props.navigation.selectedStation !== -1) {
                user_details_url = user_details_url.concat(`&global_code=${this.props.navigation.selectedStation}`);
            }
            axios
                .get(user_details_url, {...tokenHeader(), cancelToken: source.token})
                .then((response) => this.setState({
                    data: response.data.products, filteredData: response.data.products,
                    xhr: false, axiosSource: null
                }))
                .catch(ajaxHandler);
        }
    };


    filterCategory = (category) => {
        let filteredKeys = this.state.filteredKeys;
        if (this.state.filteredKeys.indexOf(category) === -1) {
            filteredKeys.push(category);
        } else {
            filteredKeys = _.filter(filteredKeys, (key) => {
                return key !== category
            })
        }

        this.setState({filteredKeys})
    };

    render() {
        const values = this.props.filters;

        let data = this.state.data ? this._getFormattedData() : [];
        return (
            <div className={"container"}>
                {this.state.data && data &&
                <div>
                    <div className={"subtitle-select-turn"}>
                        <div className={"subtitle"}>Desempeño por turno y día de la semana</div>
                        <Select className={"select"} values={values} selectedValue={this.state.selectedValue}
                                onValueChange={this.onValueChange}/>
                    </div>
                    <div>
                        <div className={"chart-labels"}>
                            <div className={"label left"}>Litros a través de Shell LATAM Pass</div>
                            <div className={"label right"}>Total (lts)</div>
                        </div>
                        <div className={'bar-chart'}>
                            <BarChart turn={"Mañana"} img={morning}
                                      data={data.dataMorning.filter(serie => this.state.filteredKeys.indexOf(serie.name) === -1)}
                            />
                            <BarChart turn={"Tarde"} img={afternoon} height={30}
                                      data={data.dataAfternoon.filter(serie => this.state.filteredKeys.indexOf(serie.name) === -1)}
                            />
                            <BarChart turn={"Noche"} img={night}
                                      data={data.dataNight.filter(serie => this.state.filteredKeys.indexOf(serie.name) === -1)}
                            />
                        </div>

                        <div className={"categories"}>
                            <Category color={'#00B050'} text={"V-Power Nafta"}
                                      onClick={() => this.filterCategory('V-Power Nafta')}/>
                            <Category color={'#0099FF'} text={"V-Power Diesel"}
                                      onClick={() => this.filterCategory('V-Power Diesel')}/>
                            <Category color={'#DD1D21'} text={"Super Nafta"}
                                      onClick={() => this.filterCategory('Super Nafta')}/>
                        </div>
                    </div>
                </div>
                }
                {!this.state.data &&
                <VerticalAlign>
                    <LoadingSpinner className={'spinner'} width={50}/>
                </VerticalAlign>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        filters: state.filters,
        navigation: state.navigation,
        stations: state.stations
    }
};

export default connect(mapStateToProps)(PerformancePerTurn);



// WEBPACK FOOTER //
// ./src/containers/dashboard-spl/performancePerTurn/PerformancePerTurn.js